import { Badge, Box, Button, Heading, Table, Tbody, Td, Text, Th, Thead, Tr, VStack } from '@chakra-ui/react';
import { format } from 'date-fns';
import { useState } from 'react';
import { FiEye } from 'react-icons/fi';

export default function Orders() {
    const [orders, setOrders] = useState([]);

    const formatDate = (dateString) => {
        try {
            return format(new Date(dateString), 'dd MMM yyyy, HH:mm');
        } catch {
            return dateString;
        }
    };

    const getStatusColor = (status) => {
        const statusColors = {
            completed: 'green',
            pending: 'yellow',
            processing: 'blue',
            cancelled: 'red',
            failed: 'red',
        };
        return statusColors[status?.toLowerCase()] || 'gray';
    };

    return (
        <VStack spacing={{ base: 4, md: 6 }} align='stretch' w='full'>
            <Box mt={{ base: 5, md: 0 }} mb={3}>
                <Heading size={{ base: 'md', md: 'lg' }} color='gray.800' mb={{ base: 0, md: 2 }} textAlign={{ base: 'center', md: 'left' }}>
                    Orders
                </Heading>
                <Text color='gray.600' fontSize={{ base: 'sm', md: 'md' }} textAlign={{ base: 'center', md: 'left' }}>
                    View your order history and status
                </Text>
            </Box>

            <Box bg='white' borderRadius='2xl' p={{ base: 4, md: 6 }} shadow='sm' border='1px' borderColor='gray.100'>
                {orders.length === 0 ? (
                    <Box textAlign='center' py={12}>
                        <Text fontSize='6xl' mb={4}>
                            📦
                        </Text>
                        <Text color='gray.500' fontSize={{ base: 'md', md: 'lg' }}>
                            No orders yet
                        </Text>
                    </Box>
                ) : (
                    <>
                        {/* Desktop: Table View */}
                        <Box overflowX='auto' display={{ base: 'none', md: 'block' }}>
                            <Table variant='simple'>
                                <Thead>
                                    <Tr>
                                        <Th>Order Number</Th>
                                        <Th>Date</Th>
                                        <Th>Items</Th>
                                        <Th isNumeric>Total</Th>
                                        <Th>Status</Th>
                                        <Th>Action</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {orders.map((order) => (
                                        <Tr key={order.id}>
                                            <Td fontWeight='semibold'>{order.orderNumber}</Td>
                                            <Td fontSize='sm'>{formatDate(order.date)}</Td>
                                            <Td fontSize='sm'>{order.items.length} item(s)</Td>
                                            <Td isNumeric fontWeight='semibold'>
                                                Rp {order.total.toLocaleString('id-ID')}
                                            </Td>
                                            <Td>
                                                <Badge colorScheme={getStatusColor(order.status)} borderRadius='full' px={3}>
                                                    {order.status}
                                                </Badge>
                                            </Td>
                                            <Td>
                                                <Button
                                                    size='sm'
                                                    leftIcon={<FiEye />}
                                                    colorScheme='purple'
                                                    variant='ghost'
                                                    onClick={() => {
                                                        console.log('View order:', order.id);
                                                    }}>
                                                    View
                                                </Button>
                                            </Td>
                                        </Tr>
                                    ))}
                                </Tbody>
                            </Table>
                        </Box>

                        {/* Mobile: Card View */}
                        <VStack spacing={3} display={{ base: 'flex', md: 'none' }}>
                            {orders.map((order) => (
                                <Box key={order.id} p={4} bg='gray.50' borderRadius='lg' w='full' border='1px' borderColor='gray.200'>
                                    <Flex justify='space-between' align='start' mb={3}>
                                        <VStack align='start' spacing={1} flex={1}>
                                            <Text fontSize='sm' fontWeight='bold' color='gray.800'>
                                                {order.orderNumber}
                                            </Text>
                                            <Text fontSize='xs' color='gray.500'>
                                                {formatDate(order.date)}
                                            </Text>
                                            <Text fontSize='xs' color='gray.600'>
                                                {order.items.length} item(s)
                                            </Text>
                                        </VStack>
                                        <Badge colorScheme={getStatusColor(order.status)} borderRadius='full' px={2} fontSize='xs'>
                                            {order.status}
                                        </Badge>
                                    </Flex>
                                    <Flex justify='space-between' align='center'>
                                        <Text fontSize='lg' fontWeight='bold' color='gray.800'>
                                            Rp {order.total.toLocaleString('id-ID')}
                                        </Text>
                                        <Button
                                            size='sm'
                                            leftIcon={<FiEye />}
                                            colorScheme='purple'
                                            variant='outline'
                                            onClick={() => {
                                                console.log('View order:', order.id);
                                            }}>
                                            View
                                        </Button>
                                    </Flex>
                                </Box>
                            ))}
                        </VStack>
                    </>
                )}
            </Box>
        </VStack>
    );
}
